/**
 * Plain meta label — source, frequency, plan, industry, "You".
 * Not a status: no fill, no border, no status color (RD-UI-030).
 */

import { foundation } from './tokens';

const { color, fontSize, fontWeight } = foundation;

export function metaTextStyle({ muted = false } = {}) {
  return {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    whiteSpace: 'nowrap',
    fontSize: fontSize.xs,
    fontWeight: fontWeight.medium,
    lineHeight: 1.2,
    color: muted ? color.neutral.textMuted : color.neutral.textSecondary,
    background: 'transparent',
    border: 'none',
    padding: 0,
    boxShadow: 'none',
  };
}
